import { render, staticRenderFns } from "./GridRegister.vue?vue&type=template&id=9dcb8892&scoped=true&"
import script from "./GridRegister.vue?vue&type=script&lang=js&"
export * from "./GridRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcb8892",
  null
  
)

export default component.exports